import { type TrackTypeEnum } from '@/entities/tracks'

export type AuthorEditPageTabsKeys =
  | 'common'
  | Lowercase<Exclude<keyof typeof TrackTypeEnum, 'Jingle'>>
  | 'album'
  | 'albumcollection'
  | 'settings'
export const AuthorEditPageTabsKeysEnum: Record<
  AuthorEditPageTabsKeys,
  AuthorEditPageTabsKeys
> = {
  common: 'common',
  music: 'music',
  podcast: 'podcast',
  sermon: 'sermon',
  audiobook: 'audiobook',
  album: 'album',
  albumcollection: 'albumcollection',
  settings: 'settings',
} as const
export const DEFAULT_AUTHOR_EDIT_PAGE_TAB: AuthorEditPageTabsKeys = 'common'
export const AuthorEditPageTabsKeysArray: AuthorEditPageTabsKeys[] = [
  'common',
  'music',
  'podcast',
  'sermon',
  'audiobook',
  'album',
  'albumcollection',
  'settings',
]
